import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { HashRouter as Router } from 'react-router-dom';

import { ConfigProvider, Empty } from 'antd';
import 'antd/dist/antd.variable.css';
import 'ant-design-draggable-modal/dist/index.css';
import './utils/custom-antd.css';

ConfigProvider.config({
  theme: {
    primaryColor: '#198001',
  },
});

const customizeRenderEmpty = () => <Empty description="Sin datos cargados" />;

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <App />
      </ConfigProvider>
    </Provider>
  </Router>,
  document.getElementById('root')
);
